export const createEdgeDevice = async (sessionToken, thingName) => {
  const response = await fetch(
    `https://5lpvkiuz0f.execute-api.us-east-1.amazonaws.com/v1/edge/createEdgeDevice?thingName=${thingName}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: sessionToken,
      },
    }
  );
  return await response.json();
};